import switchFunc from 'lib/function/switchFunc'

import LineBanIcon from 'LuxKit/Icons/line/LineBanIcon'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import LineDollarSignAltIcon from 'LuxKit/Icons/line/LineDollarSignAltIcon'
import LineFileMinusAltIcon from 'LuxKit/Icons/line/LineFileMinusAltIcon'
import LineHeartPlusIcon from 'LuxKit/Icons/line/LineHeartPlusIcon'
import LineFilePlusAltIcon from 'LuxKit/Icons/line/LineFilePlusAltIcon'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import LineRestaurantIcon from 'LuxKit/Icons/line/LineRestaurantIcon'
import LineRefreshIcon from 'LuxKit/Icons/line/LineRefreshIcon'
import LineSyringeIcon from 'LuxKit/Icons/line/LineSyringeIcon'
import LineBusIcon from 'LuxKit/Icons/line/LineBusIcon'
import LineAwardIcon from 'LuxKit/Icons/line/LineAwardIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LineShieldCheckIcon from 'LuxKit/Icons/line/LineShieldCheckIcon'
import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'
import LineFileCheckAltIcon from 'LuxKit/Icons/line/LineFileCheckAltIcon'
import LineBackpackIcon from 'LuxKit/Icons/line/LineBackpackIcon'
import LineQuestionCircleIcon from 'LuxKit/Icons/line/LineQuestionCircleIcon'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'

const CRUISE_FINE_PRINT_SECTION_ICONS: Record<App.CruiseFinePrintSection['title'], (props: any) => React.ReactElement> = {
  '7-Day Change of Mind ‘No Questions Asked’ Refund Guarantee': LineRefreshIcon,
  'Covid-19 Related Cancellations': LineBanIcon,
  'Date Changes': LineCalendarIcon,
  Inclusions: LineFilePlusAltIcon,
  Transfers: LineBusIcon,
  Exclusions: LineFileMinusAltIcon,
  'Health & Vaccinations': LineSyringeIcon,
  'Fitness Requirements': LineHeartPlusIcon,
  'Dietary Requirements': LineRestaurantIcon,
  Surcharges: LineDollarSignAltIcon,
}

export const getFinePrintSectionIcon = switchFunc(CRUISE_FINE_PRINT_SECTION_ICONS, LineInfoCircleIcon)

const CRUISE_FAQ_ITEM_ICONS: Record<string, (props: any) => React.ReactElement> = {
  'The vendor': LineShipIcon,
  'The operator': LineAwardIcon,
  'The accommodation': LineBedIcon,
  'The differences': LineQuestionCircleIcon,
  'The experience': LineFileCheckAltIcon,
  'The service': LineShieldCheckIcon,
  'The group': LineUsersAltIcon,
  'The belongings': LineBackpackIcon,
  'The Vaccine': LineSyringeIcon,
  'The terms': LineFileCheckAltIcon,
}

export const getFAQItemIcon = switchFunc(CRUISE_FAQ_ITEM_ICONS, LineInfoCircleIcon)
